/// <reference types="google.maps" />
import * as React from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

type Props = {
  onPlaceSelect: (place: google.maps.places.PlaceResult) => void;
  /** Must contain the text input to enhance. */
  children: React.ReactNode;
};

/**
 * Attaches Google Places suggestions to the first input found in children.
 */
export function KoobPlaceAutocomplete({ onPlaceSelect, children }: Props) {
  const places = useMapsLibrary('places');
  const containerRef = React.useRef<HTMLDivElement>(null);
  const onPlaceSelectRef = React.useRef(onPlaceSelect);
  onPlaceSelectRef.current = onPlaceSelect;

  React.useEffect(() => {
    const input = containerRef.current?.querySelector('input');
    if (!places || !input) {
      return undefined;
    }

    const autocomplete = new places.Autocomplete(input);
    const listener = autocomplete.addListener('place_changed', () =>
      onPlaceSelectRef.current(autocomplete.getPlace()),
    );

    return () => {
      listener.remove();
      google.maps.event.clearInstanceListeners(autocomplete);
    };
  }, [places]);

  return <div ref={containerRef}>{children}</div>;
}
